import React, { memo } from 'react';
import { useSessionStorage } from '../../Util/Hooks/useSessionStorage.jsx';
import { ImagenesRutas } from '../../../request/RutasConfig.jsx';
//class MenuPadre extends React.Component {
function MenuPadre(props) {

    const [usuario, setUsuario] = useSessionStorage('usuarioNombreCON');
    const [imagenUsuario, setImagenUsuario] = useSessionStorage('ImagenUsuarioCON', '');
    //render() {
    const { datosMenuPadre, consMenu } = props;

    if (datosMenuPadre.raiz === consMenu.administrativo) {
        return (
            //<a href="#" className="navtext"><span>{datosMenuPadre.etiqueta}</span></a> 
            //<a className="navtext"><i className= {datosMenuPadre.icono} ></i>{` ${usuario} `}<i className="fa  fa-angle-down"></i></a> 
            <a className="navtext"><img className='menu-adm' src={(imagenUsuario.trim().length == 0 ? ImagenesRutas.userMenu : imagenUsuario)} /><span>{` ${usuario} `}</span></a>
            // <a href="#"><i className={pDatos.padre.icono}></i>{pDatos.padre.etiqueta}</a>
            //<a  className="navtext"><span>{usuario}</span></a>

        );
    }
    else {

        if (datosMenuPadre.etiqueta === "Asientos") {
            return(
            <a  className="navtext" href={datosMenuPadre.href}>
                {/*<i className={datosMenuPadre.icono}></i>*/}
                <span>{datosMenuPadre.etiqueta}</span>
            </a>);
        } else {
            return (
                <a className="navtext"><span>{datosMenuPadre.etiqueta}</span></a>
            );
        }
    }
    //} 
};

export default memo(MenuPadre);